import React, { useState } from 'react';
import { Grid, Button, Typography, TextField, CircularProgress, Hidden } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { makeStyles } from '@material-ui/core/styles';
//import Background from '../assets/img/logobackground.jfif';
import Background from '../assets/img/homepage.jpg';
import Logo from '../assets/img/ATKV_Korporatief.png';
import ImageCarousel from './ImageCarousel';

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100vh',
    },
    image: {
        backgroundImage: `url(${Background})` ,
        backgroundRepeat: 'repeat',
        backgroundColor:
            theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    },
    paper: {
        margin: theme.spacing(8, 4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.primary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    logo: {
        height: "180px",
        width: "144px"
    }
}));

const Login = (props) => {
    const classes = useStyles();
    const [currEmail, setCurrEmail] = useState('');
    const [userPass, setUserPass] = useState('');
    const [loginErr, setLoginErr] = useState(false);
    const [isLogging, setIsLogging] = useState(false);

    const authUser = () => {
        setIsLogging(true);
        // test new LDAP auth. checking for session variable being set. 
        fetch('api/User/getnewsession', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body:
                JSON.stringify({
                    "username": currEmail,
                    "password": userPass

                })

        }).then((response) => {
            if (response.ok) {
                response.json()
                    .then(data => {
                        setLoginErr(false);
                        setIsLogging(false);
                        console.log(data)
                    })
                    ;
            }
            else {
                setLoginErr(true);
            }
        });
    // no longer using below request, request was used in the past to signup/authenticate potential project participants. 
    // participants would in the past register with their email (registreer) and receive an email with their password. 
    //    fetch('api/Users/authuser',
    //        {
    //            method: "POST",
    //            headers:
    //            {
    //                "Content-Type": "application/json"
    //            },
    //            body: JSON.stringify({
    //                "email": currEmail,
    //                "pass": userPass
    //            }
    //            )
    //        })
    //        .then((response) => response.json())
    //        .then((data) => {
    //            if (data.status === 404) {
    //                setLoginErr(true);
    //                setIsLogging(false);
    //            }
    //            else {
    //                setIsLogging(false);
    //                console.log('logging data in data =>', data);
    //                props.prop1.setUserProfile(data);
    //                props.prop1.setUserAuth(true);
    //                setLoginErr(false);
    //                props.history.push('alleprojekte');

    //            }
    //        })
    }


    return (
        <Grid container component="main" className={classes.root}>
            <CssBaseline />
            <Hidden xsDown>
            <Grid item xs={12} sm={4} md={7} className={classes.image}
            >
                    {/*<ImageCarousel /> */}
                </Grid>
            </Hidden>
           
            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                <div className={classes.paper}>
                    
                    <img className={classes.logo} src={Logo} />
                    
                    <Typography component="h1" variant="h5">
                        Teken in!
          </Typography>
                    <form className={classes.form} noValidate>
                        <TextField
                            id="outlined-basic"
                            onChange={(e) => setCurrEmail(e.target.value)}
                            label="Tik jou E-pos adres hier in"
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            type="email"
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            onChange={(e) => setUserPass(e.target.value)}
                            name="password"
                            label="Tik jou wagwoord hier in"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                        />
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            onClick={() => authUser()}
                        >
                            Teken In
            </Button>
                        <Grid container>
                            <Grid item xs={12} sm={12} lg={12}>
                                <Link href="/reg" variant="body2">
                                    {"Het jy al jou e-pos registreer? Registreer eers hier!"}
                                </Link>
                            </Grid>
                            <Grid item xs={12} sm={12} lg={12}>
                                <Link href="/stuurmywagwoord" variant="body2">
                                    {"Wagwoord vergeet?"}
                                </Link>
                            </Grid>
                            {loginErr ?
                                <Typography variant="body1" color="secondary">Iets het fout gegaan! Probeer weer</Typography>
                                :
                                <Typography> </Typography>}
                            <br />
                            {isLogging ? <Grid container justify="center">
                                <CircularProgress />
                            </Grid>
                                : <br />}
                        </Grid>
                        <Box mt={5}>
                        </Box>
                    </form>
                </div>
            </Grid>
        </Grid>
    );
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/Login.js